<template>
    <div>
        <b-sidebar id="sidebar-backdrop-recruiting" :backdrop-variant="'dark'" backdrop shadow :visible="!!leadID"
            :right="true" no-header-close no-close-on-backdrop no-close-on-esc>
            <template #header="{ }" v-if="recruitingDetails">
                <div class="d-flex align-items-center w-100 justify-content-between">
                    <div class="d-flex align-items-center mr-2 header-title">
                        <div class="header-name">
                            {{ recruitingDetails.first_name }} {{ recruitingDetails.last_name }}
                        </div>
                        <b-button v-if="recruitingDetails.status === 'Hired'"
                            class="btn ml-2 f-14 pe-none d-flex justify-content-center align-items-center"
                            :variant="'primary-status'">
                            <p class="mb-0">{{ $t('recruitingDetails.statusHired') }}</p>
                        </b-button>
                        <b-button v-if="recruitingDetails.status === 'Terminated'"
                            class="btn ml-2 f-14 pe-none d-flex justify-content-center align-items-center"
                            :variant="'secondary-status'">
                            <p class="mb-0">{{ $t('recruitingDetails.statusTerminated') }}</p>
                        </b-button>
                    </div>
                    <div class="d-flex align-items-center flex-shrink-0">
                        <b-form-select class="f-14 custom-select-2"
                            v-if="recruitingDetails.status !== 'Hired' && recruitingDetails.status !== 'Terminated'"
                            v-model="recruitingDetails.status" :options="statusOptions" />
                        <b-dropdown id="dropdown-divider" text="text" class="load-dropdown-2 mt-0 ml-2">
                            <template slot="button-content">
                                <b-icon class="dots" icon="three-dots"></b-icon>
                            </template>
                            <b-dropdown-item-button class="mb-2" @click="showRecruitingDeletePopup = true">
                                <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('recruitingDetails.delete') }}</p>
                            </b-dropdown-item-button>
                            <b-dropdown-item-button @click="$bvModal.show('modal-send-app')"
                                :class="recruitingDetails.status !== 'Hired' ? 'mb-2' : ''">
                                <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('recruitingDetails.sendApp') }}</p>
                            </b-dropdown-item-button>
                            <b-dropdown-item-button v-if="recruitingDetails.status !== 'Hired'"
                                @click="showHiredStatusWarning = true">
                                <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('recruitingDetails.hireApplicant') }}</p>
                            </b-dropdown-item-button>
                        </b-dropdown>
                    </div>
                </div>
            </template>
            <div class="body" v-if="recruitingDetails">
                <div class="sidebar-tabs">
                    <div class="bg-white rounded">
                        <v-tabs class="team-tabs mb-0" v-model="activeTab" show-arrows>
                            <v-tab key="general">{{ $t('recruitingDetails.tabGeneral') }}</v-tab>
                            <v-tab key="documents">{{ $t('recruitingDetails.tabDocuments') }}</v-tab>
                            <v-tab key="notes">{{ $t('recruitingDetails.tabNotes') }}</v-tab>
                        </v-tabs>
                    </div>
                </div>
                <v-tabs-items v-model="activeTab">
                    <v-tab-item key="general">
                        <hr class="mt-0" />
                        <div class="text-left mt-4rem sidebar-b-margin">
                            <b-row class="px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('recruitingDetails.basic') }}</h3>
                                <b-col sm="12" class="mt-3">
                                    <div class="text-left">
                                        <label class="state">{{ $t('recruitingDetails.dateLabel') }}</label>
                                        <date-picker v-model="recruitingDetails.date" :formatter="momentFormat"
                                            :range-separator="' - '" @clear="recruitingDetails.date = ''"
                                            :placeholder="$t('recruitingDetails.selectDate')" class="date-picker-custom" :teleport="'body'">
                                        </date-picker>
                                        <p v-if="errors && errors.date" class="field-error">
                                            {{ errors.date[0] }}
                                        </p>
                                    </div>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('recruitingDetails.recruiterLabel') }}</label>
                                    <v-select class="bg_white w-100 f-12" v-model="recruitingOwner" :options="nameOptions"
                                        item-value="id" item-text="label" :reduce="(option) => option.id"
                                        @search="searchUsers">
                                        <span slot="no-options">{{ $t('recruitingDetails.searchRecruiter') }}</span>
                                    </v-select>
                                    <p v-if="errors && errors.owner" class="field-error">
                                        {{ errors.owner[0] }}
                                    </p>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('recruitingDetails.firstNameLabel')" class="text-left mb-0">
                                        <b-form-input v-model="recruitingDetails.first_name" :placeholder="$t('recruitingDetails.firstNamePlaceholder')"
                                            class="unit f-12" required></b-form-input>
                                        <p v-if="errors && errors.first_name" class="field-error">
                                            {{ errors.first_name[0] }}
                                        </p>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('recruitingDetails.lastNameLabel')" class="text-left mb-0">
                                        <b-form-input v-model="recruitingDetails.last_name" :placeholder="$t('recruitingDetails.lastNamePlaceholder')"
                                            class="unit f-12" required></b-form-input>
                                        <p v-if="errors && errors.last_name" class="field-error">
                                            {{ errors.last_name[0] }}
                                        </p>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('recruitingDetails.phoneLabel')" class="text-left position-relative mb-0">
                                        <b-input-group size="lg" class="w-100 f-12" prepend="+1">
                                            <b-form-input v-mask="phoneMask" class="f-12" v-model="recruitingDetails.phone"
                                                :placeholder="$t('recruitingDetails.phonePlaceholder')"></b-form-input>
                                        </b-input-group>
                                        <p v-if="errors && errors.phone" class="field-error mt-2">
                                            {{ errors.phone[0] }}
                                        </p>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('recruitingDetails.emailLabel')" class="text-left mb-0">
                                        <b-form-input v-model="recruitingDetails.email" :placeholder="$t('recruitingDetails.emailPlaceholder')"
                                            class="unit f-12" required></b-form-input>
                                        <p v-if="errors && errors.email" class="field-error">
                                            {{ errors.email[0] }}
                                        </p>
                                    </b-form-group>
                                </b-col>
                                  <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('recruitingDetails.dobLabel')" class="text-left mb-0">
                                         <date-picker v-model="recruitingDetails.dob" :formatter="momentFormat"
                                            :range-separator="' - '" @clear="recruitingDetails.dob = ''"
                                            :placeholder="$t('recruitingDetails.selectDate')" class="date-picker-custom" :teleport="'body'">
                                        </date-picker>
                                        <p v-if="errors && errors.dob" class="field-error">
                                            {{ errors.dob[0] }}
                                        </p>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('recruitingDetails.jobLabel') }}</label>
                                    <v-select class="bg_white w-100 f-12" v-model="recruitingDetails.application.job_id"
                                        :options="jobOptions" item-value="id" item-text="label"
                                        :reduce="(option) => option.id" @search="searchJobs">
                                        <span slot="no-options">{{ $t('recruitingDetails.searchJob') }}</span>
                                    </v-select>
                                    <p v-if="errors && errors.job" class="field-error">
                                        {{ errors.job[0] }}
                                    </p>
                                </b-col>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('recruitingDetails.progress') }}</h3>
                                <b-col cols="12" class="mt-2">
                                    <div v-for="(step, index) in progress" :key="index"
                                        class="d-flex items-center justify-content-between mt-3">
                                        <p class="f-14 text-grey my-0">{{ stepLabel(step.key) }}</p>
                                        <div class="d-flex align-items-center">
                                            <b-img class="cursor-pointer" @click="updateStep(step)" :src="step.status === 'Open' ? require('@/assets/check-grey.svg') : step.status === 'Complete'
                                                ? require('@/assets/Check.svg')
                                                : require('@/assets/check-yellow.svg')"></b-img>
                                            <i class="fa fa-refresh ml-2 text-main cursor-pointer"
                                                @click="refreshStep(step.key)" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </v-tab-item>
                     <v-tab-item key='documents'>
                        <div class="d-block body mb-7rem">
                            <div class="mb-3 d-flex align-items-center justify-content-between px-4 mt-4rem">
                                <h3 class="f-18 font-weight-bold text-left px-0 mb-0">{{ $t('recruitingDetails.documents') }}</h3>
                                <div class="d-flex align-items-center justify-content-end cursor-pointer"
                                     @click="$bvModal.show('modal-document')">
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.5 12V6.5V12ZM6.5 6.5V1V6.5ZM6.5 6.5H12H6.5ZM6.5 6.5H1H6.5Z"
                                            fill="#367BF6" />
                                        <path d="M6.5 12V6.5M6.5 6.5V1M6.5 6.5H12M6.5 6.5H1" stroke="#367BF6"
                                            stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                    <p class="text_primary ml-2 mb-0 fw-600">{{ $t('recruitingDetails.addDocument') }}</p>
                                </div>
                            </div>
                            <div class="px-4">
                                <div v-if="documentItems.length === 0"
                                    class="text-center text-muted py-4 bg-white rounded document-card-empty">
                                    {{ $t('recruitingDetails.noDocuments') }}
                                </div>
                                <div class="document-cards-list">
                                    <div v-for="item in documentItems" :key="item.pk" class="document-card">
                                        <div class="document-card-top">
                                            <span class="document-card-title">
                                                {{ item.document_type ? item.document_type :
                                                    '-' }}
                                            </span>
                                            <span class="document-card-date">
                                                {{ item.date || '-' }}
                                            </span>
                                        </div>
                                        <div class="document-card-divider"></div>
                                        <div class="document-card-bottom justify-content-end">
                                            <div class="document-card-actions">
                                                <svg @click="setDocumentData(item)" class="cursor-pointer"
                                                    width="20" height="15" viewBox="0 0 20 15" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M18.6426 6.19707C18.8726 6.48384 19 6.85642 19 7.24273C19 7.62904 18.8726 8.00161 18.6426 8.28838C17.186 10.052 13.8704 13.4854 10 13.4854C6.12957 13.4854 2.81403 10.052 1.35741 8.28838C1.12735 8.00161 1 7.62904 1 7.24273C1 6.85642 1.12735 6.48384 1.35741 6.19707C2.81403 4.4335 6.12957 1 10 1C13.8704 1 17.186 4.4335 18.6426 6.19707Z"
                                                        stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path
                                                        d="M10.0007 10.0154C11.533 10.0154 12.7752 8.77323 12.7752 7.24091C12.7752 5.70859 11.533 4.4664 10.0007 4.4664C8.46839 4.4664 7.2262 5.70859 7.2262 7.24091C7.2262 8.77323 8.46839 10.0154 10.0007 10.0154Z"
                                                        stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <svg @click="downloadDoc(item)" class="cursor-pointer"
                                                    width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.53943 11.3822L10.001 14.8437L13.4625 11.3822"
                                                        stroke="#FFC800" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M10.0001 14.8497V5.15741" stroke="#FFC800" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path
                                                        d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
                                                        stroke="#FFC800" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <svg @click="setDeleteDocumentData(item.id)" class="cursor-pointer"
                                                     width="19" height="20" viewBox="0 0 19 20"
                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path
                                                        d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path
                                                        d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-tab-item>
                    <v-tab-item key="notes">
                        <hr class="mt-0" />
                        <div class="text-left mt-4rem sidebar-b-margin px-2">
                            <Notes v-if="leadID" :key="leadID" :noteURL="'app/recruiting/applicant/' + leadID + '/note'"
                                :allowUpdate="true" :adjustTitle="true" @updateNotes="$emit('updateData', true)" />
                        </div>
                    </v-tab-item>
                </v-tabs-items>
            </div>
            <div class="sidebar-footer position-fixed" v-if="recruitingDetails">
                <div class="text-right modal-footer border-0 p-0">
                    <b-button :class="hasChanged ? 'mr-3' : ''" class="mx-0 h-40px w-100px" variant="secondary"
                        @click="closeDrawer">{{ $t('recruitingDetails.close') }}</b-button>
                    <b-button class="mx-0 mb-0 h-40px w-100px mt-0" variant="primary" v-if="hasChanged"
                        @click="updateRecruitingDetails()">{{ $t('recruitingDetails.save') }}</b-button>
                </div>
            </div>
        </b-sidebar>
        <DeleteModal v-if="showRecruitingDeletePopup" @confirm="deleteRecruitingItem($event)" />
        <Document v-if="recruitingDetails && activeTab === 1" :id="leadID" :allowUpdateRecord="true"
            @documentsUpdated="getDocumentData" :documentItem="documentData" @popupClose="documentData = null"
            :mediaData="media" :mediaDataID="mediaID" :mediaDataType="mediaType" :addDoc="addRecruitingDoc"
            :updateDoc="updateRecruitingDoc" :driver="recruitingDetails.first_name + ' ' + recruitingDetails.last_name"
            :deleteDocItem="deleteDocumentItem" />
        <SendApp v-if="recruitingDetails" :data="recruitingDetails" />
        <DeleteModal v-if="showDeleteDocumentPopup" @confirm="deleteDocumentItem($event)" />
        <DeleteModal :message="$t('recruitingDetails.hiredWarning')" :updateMessage="true" :removeMessage="''" v-if="showHiredStatusWarning"
            @confirm="verifyDriverStatus" />
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import * as moment from "moment-timezone";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DeleteModal from "@/components/DeleteModal.vue";
import { checkValueExists, checkEmail } from "@/services/helper";
import Notes from "@/components/Shared/Notes";
import SendApp from "@/components/Recruiting/SendApp.vue";
import Document from './Document.vue';

export default {
    name: "RecruitingDetails",
    props: {
        leadID: { type: [String, Number, null], default: null },
        initialTab: { type: Number, default: 0 }
    },
    components: {
        DatePicker,
        vSelect,
        DeleteModal,
        Notes,
        SendApp,
        Document
    },
    data() {
        return {
            moment,
            showHiredStatusWarning: false,
            showRecruitingDeletePopup: false,
            checkValueExists,
            showDeleteDocumentPopup: false,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            recruitingDetails: null,
            activeTab: 0,
            defaultData: null,
            nameOptions: [],
            mediaType: null,
            jobOptions: [],
            checkEmail,
            errors: {},
            currentDocumentPage: 1,
            documentItems: [],
            documentFields: [
                { label: "Date", key: "date", sortable: true, thClass: 'font-table-weight-bold' },
                { label: "Document Type", key: "document_type", sortable: true, thClass: 'font-table-weight-bold' },
                { key: "Action", sortable: true, thClass: 'font-table-weight-bold' },
            ],
            fileId: null,
            manifestFiles: [],
            mediaID: null,
            docName: '',
            media: null,
            resultData: [],
            recruitingOwner: null,
            documentData: null,
            documentID: null,
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            progress: [
                { label: "Application", status: "Open", key: "application_status" },
                { label: "License", status: "Open", key: "license_status" },
                { label: "Medical Card", status: "Open", key: "medical_card_status" },
                { label: "MVR", status: "Open", key: "mvr_status" },
                { label: "PSP", status: "Open", key: "psp_status" },
                { label: "Clearinghouse", status: "Open", key: "clearinghouse_status" },
                { label: "Drug Test", status: "Open", key: "drug_test_status" },
                { label: "Past Emp.", status: "Open", key: "past_emp_status" },
                { label: "Onboarding", status: "Open", key: "onboarding_status" }
            ]
        }
    },
    computed: {
        ...mapGetters(["userCompany", "allTeamMembers"]),
        statusOptions() {
            return [
                { text: this.$t('recruitingPage.statusNewLead'), value: 'New Lead' },
                { text: this.$t('recruitingPage.statusContacted'), value: 'Contacted' },
                { text: this.$t('recruitingPage.statusFollowUp'), value: 'Follow Up' },
                { text: this.$t('recruitingPage.statusOnboarding'), value: 'Onboarding' },
                { text: this.$t('recruitingPage.statusLeadClosed'), value: 'Lead Closed' },
                { text: this.$t('recruitingPage.statusApplied'), value: 'Applied' },
                { text: this.$t('recruitingPage.statusUnderReview'), value: 'Under Review' },
                { text: this.$t('recruitingPage.statusScreening'), value: 'Screening' },
                { text: this.$t('recruitingPage.statusRejected'), value: 'Rejected' },
            ];
        },
        hasChanged() {
            if (!this.recruitingDetails || !this.defaultData) return false;
            return this.recruitingOwner != (this.defaultData?.owner?.id || null) || Object.keys(this.recruitingDetails).filter(field => {
                if (field !== 'owner') {
                    if (field === 'date') {
                        const loadDate = this.recruitingDetails.date ? moment(this.recruitingDetails.date).format('YYYY-MM-DD') : null;
                        const defaultDate = this.defaultData.date ? moment(this.defaultData.date).format('YYYY-MM-DD') : null;
                        return loadDate !== defaultDate;
                    }
                    if (field === 'phone') return this.recruitingDetails.phone.replace(/[-\s]/g, '') !== this.defaultData.phone.replace(/[-\s]/g, '');
                    if (typeof this.recruitingDetails[field] === 'object') return JSON.stringify(this.recruitingDetails[field]) !== JSON.stringify(this.defaultData[field])
                    return this.checkValueExists(this.recruitingDetails[field]) != this.checkValueExists(this.defaultData[field])
                } return false
            }).length > 0
        },
        phoneMask() {
            return this.recruitingDetails?.phone?.length > 0
                ? [
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, /\d/
                ]
                : false;
        }
    },
    watch: {
        leadID: {
            async handler(val) {
                if (val) {
                    this.activeTab = this.initialTab || 0;
                    await this.fetchRecruitingDetails();
                    await this.getDocumentData();
                } else {
                    this.recruitingDetails = null;
                    this.defaultData = null;
                    this.documentItems = [];
                    this.errors = {};
                }
            },
            immediate: true
        }
    },
    methods: {
        ...mapActions(["getRecruitingDetails", "setLoader", "getFilteredDrivers", "deleteManifestFile", "setNotification", "deleteRecruitingData", "updateRecruitingItem", "getRecruitingData", "getAllTeamMembers", "getRecruitingDocs", "deleteRecruitingDocument", "addRecruitingDoc", "updateRecruitingDoc"]),
        stepLabel(key) {
            const map = {
                application_status: 'stepApplication',
                license_status: 'stepLicense',
                medical_card_status: 'stepMedicalCard',
                mvr_status: 'stepMvr',
                psp_status: 'stepPsp',
                clearinghouse_status: 'stepClearinghouse',
                drug_test_status: 'stepDrugTest',
                past_emp_status: 'stepPastEmp',
                onboarding_status: 'stepOnboarding',
            };
            return map[key] ? this.$t(`recruitingDetails.${map[key]}`) : key;
        },
        closeDrawer() {
            this.$emit('close');
        },
        async openDoc(data) {
            this.docName = data.name
            this.media = data.document
            this.mediaID = data.id
            if (data.document.includes('.pdf')) this.mediaType = 'pdf'
            else if (data.document.includes('.mp4') || data.document.includes('.mkv') || data.document.includes('.mov') || data.document.includes('.avi')) this.mediaType = 'video'
            else this.mediaType = 'image'
        },
        async verifyDriverStatus(status) {
            if (status) {
                try {
                    this.recruitingDetails.status = 'Hired'
                    await this.updateRecruitingDetails()
                    this.showHiredStatusWarning = false
                }
                catch (e) {
                    this.setLoader(false)
                    console.log(e)
                }
            }
            else {
                this.showHiredStatusWarning = false
            }
        },
        downloadDoc(data) {
            this.docName = data.name
            this.setLoader(true)
            fetch(data.document)
                .then(response => response.blob())
                .then(blob => {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `${this.docName}.${data.document.split('.').pop().split(/[#?]/)[0]}`
                    link.click();
                    link.remove()
                    this.setLoader(false)
                })
                .catch(this.setLoader(false));
        },
        setDocumentData(data) {
            this.documentData = data
            this.openDoc(data)
            this.$bvModal.show("modal-document");
        },
        setMedia(media) {
            this.media = media.file;
            this.$nextTick(() => {
                this.$bvModal.show('modal-manifest-preview');
            });
        },
        setDeleteDocumentData(id) {
            this.showDeleteDocumentPopup = true
            this.documentID = id
        },
        setFileData(id) {
            this.showActionFilePopup = true
            this.fileId = id
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async updateRecruitingDetails() {
            try {
                const nullKeys = this.checkNullValues({
                    date: this.recruitingDetails.date,
                    job: this.recruitingDetails.application.job_id,
                    first_name: this.recruitingDetails.first_name,
                    last_name: this.recruitingDetails.last_name,
                    phone: this.recruitingDetails.phone
                });
                if (this.recruitingDetails.email) {
                    if (!this.checkEmail(this.recruitingDetails.email)) {
                        throw { email: [this.$t('recruitingDetails.wrongFormat')] };
                    }
                }
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    await this.updateRecruitingItem({
                        id: this.leadID,
                        payload: { ...this.recruitingDetails, job: this.recruitingDetails.application.job_id, owner: this.recruitingOwner, date: moment(this.recruitingDetails.date).format('YYYY-MM-DD'), dob: this.recruitingDetails.dob ? moment(this.recruitingDetails.dob).format("YYYY-MM-DD"): null }
                    })
                    await this.setNotification({
                        msg: this.$t('recruitingDetails.updated'),
                        type: "success",
                        color: "green",
                    });
                    await this.fetchRecruitingDetails()
                    this.$emit('updateData', true)
                    this.setLoader(false)
                    this.closeDrawer()
                } else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('recruitingDetails.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
                this.setLoader(false)
            }
        },
        async deleteRecruitingItem(status) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteRecruitingData(`${this.leadID}/?company_id=${this.userCompany}`)
                    await this.setNotification({
                        msg: this.$t('recruitingDetails.recordDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false)
                    this.showRecruitingDeletePopup = false
                    this.$emit('updateData', true)
                    this.$emit('close')
                }
                catch (e) {
                    this.setLoader(false)
                    console.log(e)
                }
            }
            else {
                this.showRecruitingDeletePopup = false
                this.setLoader(false)
            }
        },
        async searchUsers(searchText) {
            let options = []
            let url = `page=1&page_size=20&name=${searchText}`;
            await this.getAllTeamMembers(url);
            this.allTeamMembers.map((member) => {
                options.push({
                    id: `${member.id}`,
                    label: member.user.first_name + ' ' + member.user.last_name,
                });
            });
            this.nameOptions = options
            this.nameOptions = [...new Map(this.nameOptions.map(item => [item['id'], item])).values()]
        },
        async searchJobs(searchText) {
            let options = []
            let url = `page=1&page_size=20&name=${searchText}`;
            const data = await this.getRecruitingData({ type: "job", url });
            data.data.map((job) => {
                options.push({
                    id: `${job.id}`,
                    label: job.name,
                });
            });
            this.jobOptions = options
            this.jobOptions = [...new Map(this.jobOptions.map(item => [item['id'], item])).values()]
        },
        async fetchRecruitingDetails() {
            if (!this.leadID) return;
            try {
                this.setLoader(true);
                const data = await this.getRecruitingDetails(this.leadID);
                this.recruitingDetails = data
                if (this.recruitingDetails.date) {
                    this.recruitingDetails.date = moment.tz(this.recruitingDetails.date, this.userTimeZone).toDate();
                }
                if (this.recruitingDetails.dob) {
                    this.recruitingDetails.dob = moment.tz(this.recruitingDetails.dob, this.userTimeZone).toDate();
                }
                this.defaultData = JSON.parse(JSON.stringify(this.recruitingDetails))
                if (this.recruitingDetails?.owner) {
                    this.nameOptions = [{
                        id: this.recruitingDetails.owner.id,
                        label: this.recruitingDetails.owner.name,
                    }]
                    this.recruitingOwner = this.recruitingDetails.owner.id
                } else {
                    this.recruitingOwner = null
                }
                if (this.recruitingDetails?.application) {
                    this.jobOptions = [{
                        id: `${this.recruitingDetails.application.job_id}`,
                        label: this.recruitingDetails.application.job_name,
                    }]
                }
                [...this.progress].forEach(step => {
                    step.status = this.recruitingDetails[step.key] ? this.recruitingDetails[step.key] : 'Open';
                });
                this.setLoader(false);
            } catch (error) {
                console.error(error);
                this.setLoader(false);
            }
        },
        async updateStep(step) {
            if (step.status === 'Complete') return;
            if (step.status === 'Open') step.status = 'Pending';
            else if (step.status === 'Pending') step.status = 'Complete';
            this.recruitingDetails[step.key] = step.status;
            this.progress = this.progress.map(s => s.key === step.key ? step : s);
            await this.updateRecruitingDetails();
        },
        async refreshStep(key) {
            this.recruitingDetails[key] = 'Open';
            this.progress = this.progress.map(s => s.key === key ? { ...s, status: 'Open' } : s);
            await this.updateRecruitingDetails();
        },
        async getDocumentData() {
            if (!this.leadID) return;
            this.documentItems = []
            const data = await this.getRecruitingDocs({ id: this.leadID })
            data.map((item) => {
                this.documentItems.push({
                    id: item.id,
                    date: item.date ? moment(item.date).format("ll") : '-',
                    document: item.document,
                    document_type: item.document_type
                })
            })
        },
        async deleteDocumentItem(status, id = null) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteRecruitingDocument({
                        id: this.leadID,
                        documentID: `${id ? id : this.documentID}/?company_id=${this.userCompany}`
                    })
                    await this.setNotification({
                        msg: this.$t('recruitingDetails.documentDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.getDocumentData()
                    this.documentID = null
                    this.showDeleteDocumentPopup = false
                    this.setLoader(false)
                }
                catch (e) {
                    this.setLoader(false)
                    console.log(e)
                }
            } else {
                this.documentID = null
                this.showDeleteDocumentPopup = false
            }
        },
    },
}
</script>
<style scoped>
/* A long name wraps onto a second line instead of pushing the status picker and
   the row menu past the edge of the drawer. */
.header-title {
    min-width: 0;
}

.header-name {
    white-space: normal;
    overflow-wrap: anywhere;
    line-height: 1.2;
    text-align:left;
}

.delete-manifest-file {
    position: absolute;
    right: 2px;
    top: 2px;
    z-index: 1;
    cursor: pointer;
    color: black;
}

.h-300px {
    height: 300px;
}

.manifest-file-icon {
    height: 80px;
    width: 80px;
    background: #F5F5F5;
    border-radius: 8px;
}
</style>
